window.addEventListener("load", function() {
    var mandatoryElements = ["contact[prefix]", "contact[first_name]", "contact[last_name]", "contact[email]", "contact[phone_number]", "contact[phone_code]"];
    var termsCheckbox = document.getElementsByName("contact[terms]")[0];

    var submitButtonForStep1 = document.getElementById("rolex-contact-go-to-step2");
    var submitButtonForStep2 = document.getElementById("rolex-contact-send");
    var backButtonForStep2 = document.getElementById("rolex-contact-go-to-step1");

    // first button verify that textarea with name contact[message] is not empty and hide step 1 to show step 2
    if(submitButtonForStep1 != null || submitButtonForStep2 != null || backButtonForStep2 != null) {
        submitButtonForStep1.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            // remove error message if exists
            removeErrorMessages();

            var messageElement = document.getElementsByName("contact[message]")[0];
            var message = messageElement.value;
            if (message.length > 0) {
                document.getElementById("rolex-contact-step1").style.display = "none";
                document.getElementById("rolex-contact-step2").style.display = "flex";
                backButtonForStep2.style.display = "flex";
            } else {
                messageElement.setAttribute("aria-invalid", "true");
                // add small error message
                var errorElement = document.createElement("small");
                errorElement.classList.add("rolex-error-message");
                errorElement.classList.add("rolex-bold");
                errorElement.innerText = necessaryFieldLabel;
                messageElement.parentNode.classList.add("error");
                messageElement.parentNode.appendChild(errorElement);

            }
        });

        // handle back button to show step 1
        backButtonForStep2.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            document.getElementById("rolex-contact-step1").style.display = "flex";
            document.getElementById("rolex-contact-step2").style.display = "none";
            backButtonForStep2.style.display = "none";
        });

        // handle second button to send email
        submitButtonForStep2.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            // remove error message if exists
            removeErrorMessages();

            var error = false;

            mandatoryElements.forEach(function(elementName) {
                var element = document.getElementsByName(elementName)[0];
                var value = element.value;
                if (value.length === 0) {
                    element.setAttribute("aria-invalid", "true");
                    // add small error message
                    var errorElement = document.createElement("small");
                    errorElement.classList.add("rolex-bold");
                    errorElement.classList.add("rolex-error-message");
                    errorElement.innerText = necessaryFieldLabel;
                    element.parentNode.classList.add("error");
                    element.parentNode.appendChild(errorElement);
                    error = true;
                }
            });

            if (termsCheckbox.checked === false) {
                termsCheckbox.setAttribute("aria-invalid", "true");
                // add small error message
                var errorElement = document.createElement("small");
                errorElement.classList.add("rolex-bold");
                errorElement.classList.add("rolex-error-message");
                errorElement.innerText = necessaryFieldLabel;
                termsCheckbox.parentNode.parentNode.classList.add("error");
                termsCheckbox.parentNode.parentNode.appendChild(errorElement);
                error = true;
            }

            if(error === true) {
                // scroll to first error
                var errorElements = document.getElementsByClassName("error");
                var firstErrorElement = errorElements[0];
                firstErrorElement.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                return;
            }

            $(document).trigger("rolex-contact-send");
            document.getElementById("RolexContactForm").submit();
        });

        backButtonForStep2.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            document.getElementById("rolex-contact-step1").style.display = "flex";
            document.getElementById("rolex-contact-step2").style.display = "none";
            backButtonForStep2.style.display = "none";
        });
    }

    // handle email and/or phone number validation
    var emailElement = document.getElementsByName("contact[email]")[0];
    var phoneNumberElement = document.getElementsByName("contact[phone_number]")[0];
    var phoneCodeElement = document.getElementsByName("contact[phone_code]")[0];

    // if email is filled then phone number is not mandatory
    if(emailElement != null && phoneNumberElement != null && phoneCodeElement != null) {
        var index;
        emailElement.addEventListener("input", function() {
            if(emailElement.value.length > 0) {
                phoneNumberElement.removeAttribute("required");
                phoneCodeElement.removeAttribute("required");
                index = mandatoryElements.indexOf("contact[phone_number]");
                if (index > -1) {
                    mandatoryElements.splice(index, 1);
                }
                index = mandatoryElements.indexOf("contact[phone_code]");
                if (index > -1) {
                    mandatoryElements.splice(index, 1);
                }
            } else {
                phoneNumberElement.setAttribute("required", "required");
                phoneCodeElement.setAttribute("required", "required");
                index = mandatoryElements.indexOf("contact[phone_number]");
                if (index === -1) {
                    mandatoryElements.push("contact[phone_number]");
                }
                index = mandatoryElements.indexOf("contact[phone_code]");
                if (index === -1) {
                    mandatoryElements.push("contact[phone_code]");
                }
            }
        });

        // if phone number is filled then email is not mandatory
        phoneNumberElement.addEventListener("input", function() {
            if(phoneNumberElement.value.length > 0) {
                emailElement.removeAttribute("required");
                index = mandatoryElements.indexOf("contact[email]");
                if (index > -1) {
                    mandatoryElements.splice(index, 1);
                }
                phoneCodeElement.setAttribute("required", "required");
                index = mandatoryElements.indexOf("contact[phone_code]");
                if (index === -1) {
                    mandatoryElements.push("contact[phone_code]");
                }
            } else {
                emailElement.setAttribute("required", "required");
                index = mandatoryElements.indexOf("contact[email]");
                if (index === -1) {
                    mandatoryElements.push("contact[email]");
                }
                phoneCodeElement.removeAttribute("required");
                index = mandatoryElements.indexOf("contact[phone_code]");
                if (index > -1) {
                    mandatoryElements.splice(index, 1);
                }
            }
        });
    }

});

function removeErrorMessages()
{
    var errorElements = document.getElementsByClassName("error");
    var errorMessages = document.getElementsByClassName("rolex-error-message");

    while (errorElements.length > 0) {
        errorElements[0].classList.remove("error");
    }

    while (errorMessages.length > 0) {
        errorMessages[0].remove();
    }
}